export const QUERY_PARAMS = {
    IMPACT: 'irclickid'
};
